import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { CAMERA_ICON, DOCUMENT_OUTLINE_ICON, GALLERY_ICON, PLAY_ALT_ICON } from "../utils/svgs_new";
import { AppBottomSheet } from "./Generic/AppBottomSheet";
import { AppIcon } from "./Generic/AppIcon";
import { AppList, AppListItem } from "./Generic/AppList";
import UploadPhoto from "./UploadPhoto";

interface Props {
  isOpen: boolean;
  onClickCamera: () => void;
  onClickGallery: () => void;
  onSelectFile?: (files: FileList) => void;
  onSelectVideo?: (files: FileList) => void;
  onRequestClose: () => void;
}

const ChooseAttachmentBottomSheet = (props: Props) => {
  const handleSelectFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;

    if (files === null || files.length === 0 || props.onSelectFile === undefined) {
      return;
    }
    props.onSelectFile(files);
  };

  const handleSelectvideo = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;

    if (files === null || files.length === 0 || props.onSelectVideo === undefined) {
      return;
    }
    props.onSelectVideo(files);
  };

  return (
    <UploadPhoto.Styled isOpen={props.isOpen} onRequestClose={props.onRequestClose}>
      <AppList bordered={true}>
        <AppListItem
          leading={<AppIcon icon={GALLERY_ICON} size={20} fill="var(--gray-600)" />}
          title={translate(STRINGS.FROM_GALLERY)}
          onClick={props.onClickGallery}
        />

        <AppListItem
          leading={<AppIcon icon={CAMERA_ICON} size={20} fill="var(--gray-600)" />}
          title={translate(STRINGS.FROM_CAMERA)}
          onClick={props.onClickCamera}
        />
        {props.onSelectFile !== undefined ? (
          <>
            <label htmlFor="file-upload">
              <AppListItem
                leading={<AppIcon icon={DOCUMENT_OUTLINE_ICON} size={20} />}
                title={translate(STRINGS.ATTACH_A_DOCUMENT)}
              />
            </label>
            <input
              id="file-upload"
              type="file"
              accept=".pdf"
              style={{ display: "none" }}
              onChange={handleSelectFile}
            />
          </>
        ) : null}
        {props.onSelectVideo !== undefined ? (
          <>
            <label htmlFor="video-upload">
              <AppListItem
                leading={<AppIcon icon={PLAY_ALT_ICON} size={20} />}
                title={translate(STRINGS.UPLOAD_VIDEO)}
              />
            </label>
            <input
              id="video-upload"
              type="file"
              accept="video/*"
              style={{ display: "none" }}
              onChange={handleSelectvideo}
            />
          </>
        ) : null}
      </AppList>
    </UploadPhoto.Styled>
  );
};

ChooseAttachmentBottomSheet.Styled = styled(AppBottomSheet)`
  .AppBottomSheet_Content {
    margin: 0 !important;
  }

  .AppListItem {
    padding: 24px;
  }
`;

export default ChooseAttachmentBottomSheet;
